export default __webpack_public_path__ + "static/media/32.a1135930.jpg";